// auto-generated by Typewriter template _models.tst from PortCall.Wartsila.EndPoints\Api\EnhancedEstimate\ApiEnhancedEstimate.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { EnhancedEstimateQuery, EnhancedEstimateQueryData, EnhancedEstimateQueryOptions } from 'data/models/EnhancedEstimateQuery';
import { GeoJSONPosition, GeoJSONPositionData, GeoJSONPositionOptions } from 'data/models/GeoJSONPosition';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';

// EnhancedEstimateData is the class that EnhancedEstimate serializes to/from
export interface EnhancedEstimateData {
    Id : number;
	
    Change : ChangeData | null;
    ChangeId : number;
    EstimatedRoute : GeoJSONPositionData[] | null;
    Query : EnhancedEstimateQueryData | null;
	
    EstimatedArrival : /* ISO8601 */ string | null;
    EstimatedDistanceRemaining : NullableMeasurementData;
    TimeOfKnownVesselLocation : /* ISO8601 */ string | null;
}

// EnhancedEstimateOptions is the class which may be passed to the EnhancedEstimate constructor to define optional initial data values
export interface EnhancedEstimateOptions {
    Id : number;
	
    Change? : ChangeOptions | null;
    ChangeId? : number;
    EstimatedRoute? : GeoJSONPositionOptions[] | null;
    Query? : EnhancedEstimateQueryOptions | null;
	
    EstimatedArrival? : /* ISO8601 */ string | null;
    EstimatedDistanceRemaining? : NullableMeasurementOptions;
    TimeOfKnownVesselLocation? : /* ISO8601 */ string | null;
}

export class EnhancedEstimate {
    public Id : DataSignal<number>;
	
    public Change : DataSignal<Change | null>;
    public ChangeId : DataSignal<number>;
    public EstimatedRoute : SDataArray<GeoJSONPosition>;
    public Query : DataSignal<EnhancedEstimateQuery | null>;
	
    public EstimatedArrival : DataSignal<TZDate | null>;
    public EstimatedDistanceRemaining : NullableMeasurement;
    public TimeOfKnownVesselLocation : DataSignal<TZDate | null>;

    constructor();
    constructor(data : EnhancedEstimateOptions);
    constructor(data: EnhancedEstimateOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Change = S.value<Change | null>(null);
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.EstimatedRoute = SArray<GeoJSONPosition>([]);
        this.Query = S.value<EnhancedEstimateQuery | null>(null);
	    
        this.EstimatedArrival = jsonableObservable(S.value<TZDate | null>(data && data.EstimatedArrival !== undefined ? data.EstimatedArrival === null ? null : new TZDate(data.EstimatedArrival) : null, TZDate.nullableEq));
        this.EstimatedDistanceRemaining = data && data.EstimatedDistanceRemaining !== undefined ? new NullableMeasurement(data.EstimatedDistanceRemaining) : new NullableMeasurement();
        this.TimeOfKnownVesselLocation = jsonableObservable(S.value<TZDate | null>(data && data.TimeOfKnownVesselLocation !== undefined ? data.TimeOfKnownVesselLocation === null ? null : new TZDate(data.TimeOfKnownVesselLocation) : null, TZDate.nullableEq));
    }

    static key(obj : EnhancedEstimate) {
        return obj.Id();
    }
    
    static dataKey(obj : EnhancedEstimateOptions) {
        return obj.Id;
    }

    static update(obj : EnhancedEstimate, data : EnhancedEstimateOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
	        
            if (data.EstimatedArrival !== undefined) obj.EstimatedArrival(data.EstimatedArrival === null ? null : new TZDate(data.EstimatedArrival));
            if (data.EstimatedDistanceRemaining !== undefined) NullableMeasurement.update(obj.EstimatedDistanceRemaining, data.EstimatedDistanceRemaining);
            if (data.TimeOfKnownVesselLocation !== undefined) obj.TimeOfKnownVesselLocation(data.TimeOfKnownVesselLocation === null ? null : new TZDate(data.TimeOfKnownVesselLocation));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/EnhancedEstimate.ts